<!-- <div class="logo-client"><img src="assets/images/olios_logo.png" /></div>
<div class="header">
  <div class="container-fluid">
    <div class="row">
      <div class="col-4">
        <div> 
          <img src="assets/images/olios_logo_small.png" class="logo" />
        </div>
      </div>
      <div class="col-8">
        <div class="dropdown float-right">
          <a
            type="button"
            data-toggle="dropdown"
            class="dropdown-toggle"
            style="font-size: 18px"
          >
            Setting
          </a>
          <div class="dropdown-menu">
            <a routerLink="user/user-profile" class="dropdown-item" href="#"
              >Profile</a
            >
            <a routerLink="user/change-password" class="dropdown-item" href="#"
              >Change-password</a
            >
            <a (click)="signout()" class="dropdown-item" href="#">Logout</a>
          </div>
        </div>

        <div
          class="dropdown float-right mr-4"
          *ngFor="let parentMenuObject of parentMenuList"
        >
          <a
            type="button"
            data-toggle="dropdown"
            class="dropdown-toggle"
            style="font-size: 18px"
          >
            {{ parentMenuObject.parentMenuName }}
          </a>
          <div class="dropdown-menu">
            <a
              routerLink="{{ menu.href }}"
              class="dropdown-item"
              *ngFor="let menu of parentMenuObject.menuList"
              [ngStyle]="{
                color:
                  (location.path()?.split('?'))[0] === menu.href
                    ? '#ebb21b'
                    : '#b1b1b5'
              }"
            >
              {{ menu.name }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="line1"></div>
  <div class="line2"></div>
  <div class="container-fluid">
    <div class="title-content">
      <div class="float-left">
        <h1>
          <span
            class="orange-text"
            *ngIf="(location.path()?.split('?'))[0] === '/user'"
            >User</span
          >
          <span
            class="orange-text"
            *ngIf="(location.path()?.split('?'))[0] === '/preference'"
            >Preference</span
          >
          <span
            class="orange-text"
            *ngIf="(location.path()?.split('?'))[0] === '/admin/role'"
            >Role</span
          >
          <span
            class="orange-text"
            *ngIf="(location.path()?.split('?'))[0] === '/admin/privilege'"
            >Privilege</span
          >
          <span
            class="orange-text"
            *ngIf="(location.path()?.split('?'))[0] === '/organization'"
            >Organization</span
          >
          <span
            class="orange-text"
            *ngIf="(location.path()?.split('?'))[0] === '/user/change-password'"
            >Change Password</span
          >
          <span
            class="orange-text"
            *ngIf="(location.path()?.split('?'))[0] === '/user/user-profile'"
            >User Profile</span
          >
          <span
            class="orange-text"
            *ngIf="(location.path()?.split('?'))[0] === '/lpr-data/violation'"
            >LPR Violations</span
          >
          <span
            class="orange-text"
            *ngIf="(location.path()?.split('?'))[0] === '/lpr-data/session-data'"
            >LPR Session Data</span
          >
          <span
            class="orange-text"
            *ngIf="(location.path()?.split('?'))[0] === '/lpr-config/registered-vehicle'"
            >LPR Registered Vehicle</span
          >
          <span
            class="orange-text"
            *ngIf="(location.path()?.split('?'))[0] === '/lpr-config/camera-group'"
            >LPR Camera Group</span
          >
          <span
            class="orange-text"
            *ngIf="(location.path()?.split('?'))[0] === '/lpr-config/camera-list'"
            >LPR Camera List</span
          >
          <span
            class="orange-text"
            *ngIf="(location.path()?.split('?'))[0] === '/lpr-config/property'"
            >Property</span
          >
        </h1>
      </div>
    </div>
  </div>
</div> -->
<div class="wrapper">
<nav class="main-header navbar navbar-expand navbar-black navbar-dark">
  <!-- Left navbar links -->
  <ul class="navbar-nav">
    <li class="nav-item">
      <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
    </li>
  </ul>
  <div class="oliosLogo noselect">
    <!-- <h4 class="mb-0">{{title}}</h4> -->
    <img src="assets/images/olios_logo.png" alt="Olios" style="opacity: .8; width: 20%;">
  </div>
  <!-- <div class="olios-logo">
    <img width="80px" src="assets/images/olios_logo.png"/>
  </div> -->
  <ul class="navbar-nav ml-auto">
      <!-- Notifications Dropdown Menu -->
      <div class="nav-item dropdown">
        <a class="nav-link" data-toggle="dropdown" id="dropdownMenuLink" role="button">
          <span class="mr-2 noselect">{{userName.displayName}}</span><i class="fas fa-cog"></i>
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="dropdownMenuLink">
          <a routerLink="user/user-profile" href="#" class="dropdown-item">
            <i class="fas fa-user-alt mr-2"></i> Profile
          </a>
          <div class="dropdown-divider"></div>
          <a routerLink="user/change-password" href="#" class="dropdown-item">
            <i class="fas fa-fingerprint mr-2"></i> Change Password
          </a>
          <div class="dropdown-divider"></div>
          <a (click)="signout()" href="#" class="dropdown-item">
            <i class="fas fa-sign-out-alt mr-2"></i> Logout
          </a>
        </div>
      </div>
  </ul>
</nav>

<aside class="main-sidebar sidebar-dark-primary elevation-4">
  <!-- Brand Logo -->
  <a href="/" class="brand-link">
    <img *ngIf="isImage; else defaultlogo" [src]="getLogo()" alt="Logo" class="brand-image" style="opacity: .8">
    <ng-template #defaultlogo>
      <img src="assets/images/logo.png" alt="Olios" class="brand-image" style="opacity: .8">
    </ng-template>
    <span class="brand-text font-weight-light noselect">{{orgName}}</span>
  </a>

  <!-- Sidebar -->
  <div class="sidebar">
    <!-- Sidebar user panel (optional) -->
    <!-- <div class="user-panel mt-3 pb-3 mb-3 d-flex">
      <div class="info">
        <a href="#" class="d-block">Adeel Ali</a>
      </div>
    </div> -->

    <!-- SidebarSearch Form -->
    <!-- <div class="form-inline mt-3">
      <div class="input-group" data-widget="sidebar-search">
        <input class="form-control form-control-sidebar" type="search" placeholder="Search" aria-label="Search">
        <div class="input-group-append">
          <button class="btn btn-sidebar">
            <i class="fas fa-search fa-fw text-white"></i>
          </button>
        </div>
      </div>
    </div> -->

    <!-- Sidebar Menu -->
    <nav class="mt-2">
      <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
        <!-- Add icons to the links using the .nav-icon class
             with font-awesome or any other icon font library -->
            
        <!-- <li class="nav-item menu-open" *ngFor="let parentMenuObject of parentMenuList">
          <a href="#" class="nav-link active">
            <i class="nav-icon fas fa-tachometer-alt"></i>
            <p>
              {{ parentMenuObject.name }}
              <i class="right fas fa-angle-left"></i>
            </p>
          </a>
          <ul class="nav nav-treeview">
            <li class="nav-item" *ngFor="let menu of parentMenuList"
            [ngStyle]="{
              color:
                (location.path()?.split('?'))[0] === menu.href
                  ? '#ebb21b'
                  : '#b1b1b5'
            }">
              <a routerLink="{{ menu.href }}" class="nav-link" routerLinkActive="active">
                <i class="{{menu.cssClass}} mr-2"></i>
                <p>{{ menu.name }}</p>
                
              </a>
            </li>
          </ul>
          </li> -->
          <!-- <li class="nav-item mt-2">
            <a id="navMenuLinkERP" target="_blank" href="https://admin-parking-erp.conurets.com/#/dashboard/permit-managment/user-permit" class="nav-link" routerLinkActive="active">
              <img src="/assets/images/SBU-Logo.png" class="mr-2" style="width: 25px;">
              <p>Permit Management</p>
            </a>
          </li> -->
          <li class="nav-item mt-2" *ngFor="let menu of parentMenuList">
            <a id="navMenuLink{{menu.id}}" routerLink="{{ menu.href }}" class="nav-link" routerLinkActive="active">
              <i class="{{menu.cssClass}} mr-2"></i>
              <p>
                {{ menu.name }}
              </p>
            </a>
          </li>

      </ul>
    </nav>
    <!-- /.sidebar-menu -->
  </div>
  <!-- /.sidebar -->
</aside>
</div>